/**
 * App.js
 * Application Root Node
 *
 * @jsx React.DOM
 *
 */

// React
import React from 'react';

// Router
import Router from 'react-router-component';
const Locations = Router.Locations;
const Location = Router.Location;
const NavigatableMixin = Router.NavigatableMixin;
const RouterMixin = Router.RouterMixin;

// LUi
import {
	Container,
	Block,
	FlashContainer,
	FlashMessage,
	OffCanvas,
	Navbar,
	NavDropDown,
	NavLink,
	NavMenu,
	IconButton,
	FlatButton,
	RaisedButton
} from '../src';

// Views
import ComponentsView from './ComponentsView';
import ColorsView from './ColorsView';

import CssEvent from 'utils/css-event';

const flashMessageHeight = 43;

export default React.createClass({
	
	mixins: [ Router.RouterMixin ],

	displayName: 'App',

	getInitialState() {
		return({
			flashMessages: [{
				text: "I'm a a really cool FlashMessage",
				type: "success",
				animated: true,
				depth: 1,
				zIndex: 100,
				key: 0,
				onMessageClick: this._handleFlashMessageClick,
			}],
			toggleDisable: true
		});
	},

	getRoutes(props) {
		return props.children;
	},

	componentWillUpdate(nextProps, nextState) {
		// initial state gets lost for a second for flashMessages on navigation, not sure why
		// but this forces it back in.

		if (nextState.flashMessage === undefined) {
			nextState.flashMessages = this.state.flashMessages;
		}
	},

	render() {

		return (
			<OffCanvas ref="offcanvas" partial={true} leftWidth={300} rightWidth={300} rightPartialWidth={100}>
				{this._renderFlashMessage()}
				{this._renderNavbar()}
				<Locations>
					<Location path="/" handler={ComponentsView} />
					<Location path="/colors" handler={ColorsView} />
				</Locations>
			</OffCanvas>
		)
	},

	//////////////
	// SIDEBAR //
	//////////////

	_toggleLeftSidebar() {
		this.refs.offcanvas.toggleLeft();
	},

	_toggleRightSidebar() {
		this.refs.offcanvas.toggleRight();
	},

	_toggleExpandRightSidebar() {
		this.refs.offcanvas.toggleExpandRight();
	},

	_renderSidebarButtons() {
		return(
			<div>
				<RaisedButton
					label="Toggle Left Sidebar"
					onClick={this._toggleLeftSidebar}
					status="primary" />

					<RaisedButton
					label="Toggle Right Sidebar"
					onClick={this._toggleRightSidebar}
					status="secondary" />

					<RaisedButton
					label="Toggle Expand Right Sidebar"
					onClick={this._toggleExpandRightSidebar}
					status="success" />
			</div>
		)
	},

	////////////
	// Navbar //
	////////////

	_renderNavbar() {

		let flashOffset = this.state.flashMessages.length * flashMessageHeight;

		let menuItems = [
			{ payload: '1', text: 'One', href:'/colors'},
			{ payload: '2', text: 'Two'},
			{ payload: '3', text: 'Three'},
			{ payload: '4', text: 'Four'},
			{ payload: '5', text: 'Five'}
		];

		let logo = (
			<span>
				<h2>LUi</h2>
			</span>
		);

		return (
			<Navbar logo={logo} offsetTop={flashOffset} rightItems={this._getNavRight()} centerItems="derpoderp">
				<NavDropDown menuItems={menuItems} />
				<NavLink label="Components" href="/" />
				<NavLink label="Colors" href="/colors" />
				<NavLink label="Github" href="https://github.com/luceracloud/LUi" target="_blank" />
			</Navbar>
		);
	},

	_getNavRight() {

		let menuItems = [
			{ payload: 'my_account', text: 'My Account', icon: 'user', to: '/home'},
			{ payload: 'notifications', text: 'Notifications', icon: 'envelope-square',  number: '5', onClick: this._testCheck },
			{ payload: 'logout', text: 'Logout', icon: 'ellipsis-h' }
		];

		let menuHeader = [
			<h2> Fancy Menu </h2>
		];

		let customTrigger = (
			<IconButton icon="cogs"/>
		)

		return (
			<Container flexDirection="row" >
				<Block width={1}>
					<IconButton tooltipPosition="left" icon="dot-circle-o" tooltip="New Flash Message" onClick={this._handleAddFlash}/>
				</Block>
				<Block width={1}>
					<IconButton tooltipPosition="left" icon="chevron-circle-left" tooltip="Open Left Sidebar" onClick={this._toggleLeftSidebar}/>
				</Block>
				<Block width={1}>
					<IconButton icon="arrows-h" tooltipPosition="bottom" tooltip="Expand Right Sidebar" onClick={this._toggleExpandRightSidebar} />
				</Block>
				<Block width={1}>
					<IconButton icon="chevron-circle-right" tooltipPosition="right" tooltip="Open Right Sidebar" onClick={this._toggleRightSidebar} />
				</Block>
				<Block width={1}>
					<span className="lui-navbar-separator" />
				</Block>
				<Block width={3}>
					<RaisedButton label="Login" status="secondary" href="/colors"/>
				</Block>
				<Block width={3}>
					<RaisedButton label="Signup" status="primary" />
				</Block>
				<Block width={1}>
					<span className="lui-navbar-separator" />
				</Block>
				<Block width={2}>
					<NavMenu menuItems={menuItems} menuHeader={menuHeader} customTrigger={customTrigger}/>
				</Block>
			</Container>
		);
	},

	//////////////////
	// Progress Bar //
	//////////////////

	_renderProgressBar() {
		return(
			<div>
				<ProgressBar ref="progressBar" />
				<Container>
					<Block width="200px" margin={true}>
						<TextField
							ref="barInput"
							name="Bar %"
							onEnterKeyDown={this._setPercent} />
					</Block>
					<Block width="150px" margin={true}>
						<RaisedButton label="Set Progress" onClick={this._setPercent} />
					</Block>
				</Container>
			</div>
		);
	},

	_getProgressBarTools() {
		return(
			<span>
				<IconButton icon="refresh" onClick={this._progressStart} tooltip="Start" />
				<IconButton icon="times" onClick={this._progressDone} tooltip="Done" />
			</span>
		);
	},

	_progressStart() {
		this.refs.progressBar.start();
	},

	_progressDone() {
		this.refs.progressBar.done();
	},

	_progressAdd() {
		this.refs.progressBar.addButton();
	},

	_setPercent() {
		this.refs.progressBar.toPercent(this.refs.barInput.getValue());
	},

	///////////////////
	// FlashMessage  //
	///////////////////

	_renderFlashMessage(){
		
		let	flashMessages = this.state.flashMessages.map(function(message, i) {
			return <FlashMessage
					key={message.key}
					uuid={i}
					animated={message.animated}
					text={message.text}
					type={message.type}
					zIndex={message.zIndex}
					onMessageClick={message.onMessageClick}
					onDismiss={this._handleDismiss}
					closeCustomFontIcon={message.closeCustomFontIcon} />
		}.bind(this));

		return (
			<FlashContainer>
				{flashMessages}
			</FlashContainer>
		);
	},

	_handleAddFlash() {
		var data = this.state.flashMessages.slice(0); // Clone this.state.flashMessages array
		// Push to cloned array
		data.push({
				text: 'I am a NEW Flash Message',
				animated: true,
				type: 'notice',
				depth: 1,
				zIndex: this.state.flashMessages.length ? this.state.flashMessages[this.state.flashMessages.length-1].zIndex-1 : 100, // zIndex of the last child in array -1
				onMessageClick: this._handleFlashMessageClick,
				key: this.state.flashMessages.length ? this.state.flashMessages[this.state.flashMessages.length-1].key+1 : 0 // get key of last child in array and +1
			})

		// Set the cloned array as the new array.
		this.setState({
			flashMessages: data
		});
	},

	_handleDismiss(index) {
		console.log(index);
		var data = this.state.flashMessages;
		data.splice(index, 1);

		this.setState({ flashMessages: data });
	},

	_getFlashMessageTools() {
		return(
			<span>
				<IconButton onClick={this._handleAddFlash} icon="dot-circle-o" tooltip="Add Flash Message" />
			</span>
		);
	},

	_handleFlashMessageClick(){
		console.log('I got clicked, go me!')
	}

});






/** WEBPACK FOOTER **
 ** ./examples/App.js
 **/